import { render, staticRenderFns } from "./Contest.vue?vue&type=template&id=21cbe47b&scoped=true&"
import script from "./Contest.vue?vue&type=script&lang=ts&"
export * from "./Contest.vue?vue&type=script&lang=ts&"
import style0 from "./Contest.vue?vue&type=style&index=0&id=21cbe47b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cbe47b",
  null
  
)

export default component.exports